import React, {useEffect, useState} from 'react'
import { Row } from "react-bootstrap"

export function ImageShow(props) {
    const [images, setImage] = useState([])
    useEffect(() => {
        setImage(props.baseImg)
    }, [props.baseImg])
    return (
        <Row>
            {
                images
                &&
                images.map((image, index) => {
                    return (
                        <img
                            key={index}
                            className="form-image"
                            width="200px"
                            src={image}
                        />
                    )
                })
            }
        </Row>
    )
}
